import * as angular from "angular";
import { EffortDataProvider } from "./effort.dp";
import { EventModel } from "../models/event.model";
import { EventService } from "../services/event.service";

export class EventDataProvider {
    private $q: any;
    private $filter: any;
    private service: EventService;
    private effortDataProvider: EffortDataProvider;
    private modelsUtils: any;

    constructor(
        $q: any,
        $filter: any,
        EventService: EventService,
        EffortDataProvider: EffortDataProvider,
        ModelsUtils: any
    ) {
        this.$q = $q;
        this.$filter = $filter;
        this.service = EventService;
        this.effortDataProvider = EffortDataProvider;
        this.modelsUtils = ModelsUtils;
    }

    all(filters: any): Promise<EventModel[]> {
        const deferred = this.$q.defer();

        this.service.all({ filters: filters }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    let events = [];

                    angular.forEach(json.data, (event: object) => {
                        events.push(this.modelsUtils.event(event));
                    });

                    deferred.resolve(events);
                } else {
                    deferred.reject(json);
                }
            },
            (response: object) => deferred.reject(response)
        );

        return deferred.promise;
    }

    user(filters: any): Promise<EventModel[]> {
        const deferred = this.$q.defer();

        this.service.user({ filters: filters }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    let events = [];

                    angular.forEach(json.data, (event: object) => {
                        events.push(this.modelsUtils.event(event));
                    });

                    deferred.resolve(events);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    info(id: string | number): Promise<EventModel> {
        const deferred = this.$q.defer();

        this.service.info({ id: id }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    let event = this.modelsUtils.event(json.data);

                    this.effortDataProvider
                        .getEffortById(event.effortid, false)
                        .then((effort: object) => {
                            event.effort = effort;
                            deferred.resolve(event);
                        });
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    between(start: any, end: any): Promise<EventModel[]> {
        const deferred = this.$q.defer();

        this.service
            .between({
                start: this.$filter("date")(start, "yyyy-MM-dd H:mm:ss"),
                end: this.$filter("date")(end, "yyyy-MM-dd H:mm:ss"),
            })
            .then(
                (response: object) => {
                    const json = response["data"];
                    if (json.success) {
                        let events = [];
                        angular.forEach(json.data, (event: object) => {
                            events.push(this.modelsUtils.event(event));
                        });
                        deferred.resolve(events);
                    } else {
                        deferred.reject(json);
                    }
                },
                (error: object) => deferred.reject(error)
            );

        return deferred.promise;
    }

    create(event: EventModel): Promise<any> {
        let deferred = this.$q.defer();

        this.service.create(event).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    update(event: EventModel): Promise<any> {
        const deferred = this.$q.defer();

        this.service.update(event).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    cancel(event: EventModel): Promise<boolean> {
        const deferred = this.$q.defer();

        this.service.cancel({ id: event.id }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data[0]);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    sendRsvp(event: EventModel, status: any): Promise<any> {
        const deferred = this.$q.defer();

        this.service.rsvp({ id: event.id, status: status }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getRsvp(id: number | string): Promise<any> {
        const deferred = this.$q.defer();

        this.service.getRsvp({ id: id }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("EventDataProvider", EventDataProvider);
